import React from "react";
import { Alert } from "reactstrap";
import { statusFormatter } from "src/shared/utils/src";

type IProps = { 
    statusString: string 
}

const ErrorStatusTag: React.FC<IProps> = ({ statusString }) => {

    return (
        <Alert color="danger" className="status-tag d-inline-flex align-items-center justify-content-center fs-12 fw-medium">
            { statusFormatter(statusString) }
        </Alert>
    )
}

export default ErrorStatusTag;